export enum Feature {
  FEATURE_SHOW_INCOMPLETE_EVENTS_NOTIFICATION = 'showIncompleteEventsNotification',
  FEATURE_REQUIRE_MARITAL_RIGHTS_FOR_SPOUSE = 'requireMaritalRightsForSpouse',
}
